// extracted by mini-css-extract-plugin
module.exports = {"anchor__text":"anchor_anchor__text__Q9_dr","icon":"anchor_icon__2ibmj"};